/**
 * US phone number live-formatter.
 *
 * Accepts any user input, strips non-digits, returns "(212) 555-1234" style
 * formatting. Used as the onChange shaper for type="tel" inputs.
 *
 * Behaviour:
 *  - 0 digits → empty string
 *  - 1-3 digits → "212"
 *  - 4-6 digits → "(212) 555"
 *  - 7-10 digits → "(212) 555-1234"
 *  - 11 digits with leading 1 → "+1 (212) 555-1234"
 *  - 12+ digits → truncate to 11 (US/Canada only)
 */
export function formatUSPhone(raw) {
  if (raw == null) return "";
  const digits = String(raw).replace(/\D/g, "").slice(0, 11);
  if (!digits) return "";
  // Strip leading 1 unless we end up with all 11
  if (digits.length === 11 && digits.startsWith("1")) {
    const rest = digits.slice(1);
    return `+1 (${rest.slice(0, 3)}) ${rest.slice(3, 6)}-${rest.slice(6)}`;
  }
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

// E.164 normaliser the backend already accepts.
export function toE164(raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith("1")) return `+${digits}`;
  return `+${digits}`;
}

// Returns true once the user has typed enough to look like a real US number.
export function isCompleteUSPhone(raw) {
  const digits = String(raw || "").replace(/\D/g, "");
  return digits.length === 10 || (digits.length === 11 && digits.startsWith("1"));
}

// Email validation — kept generous; the backend is the source of truth.
const EMAIL_RX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const isValidEmail = (s) => EMAIL_RX.test(String(s || "").trim());
